// extracted by mini-css-extract-plugin
module.exports = {"container":"inputTextFrontProjectForm_container__2gw72","content":"inputTextFrontProjectForm_content__1707D","input":"inputTextFrontProjectForm_input__Ub67m","required":"inputTextFrontProjectForm_required__3uaXV","placeholder":"inputTextFrontProjectForm_placeholder__38y0I","input_error":"inputTextFrontProjectForm_input_error__2zYQo","inputError":"inputTextFrontProjectForm_input_error__2zYQo"};
    if(module.hot) {
      // 1790670320853
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  